import { render, staticRenderFns } from "./DxSideBySideTypeOfWorker.vue?vue&type=template&id=6a48c4c3&"
import script from "./DxSideBySideTypeOfWorker.vue?vue&type=script&lang=js&"
export * from "./DxSideBySideTypeOfWorker.vue?vue&type=script&lang=js&"
import style0 from "./DxSideBySideTypeOfWorker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports